import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2 } from 'lucide-react'

import { Button } from '@/common/ui/button'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import useMutationDeleteRank from '@/modules/manage-rank/api/hooks/useMutateDeleteRank'
import { RankQueryKeys } from '@/modules/manage-rank/keys'

interface DeleteRankButtonProps {
	id: string
	name: string
}

export default function DeleteRankButton({ id, name }: DeleteRankButtonProps) {
	const queryClient = useQueryClient()
	const [open, setOpen] = useState(false)

	const { mutate: deleteRank, isPending } = useMutationDeleteRank({
		onSuccess: () => {
			toast.success('ลบ Rank สำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [RankQueryKeys.GetRankList],
			})
			setOpen(false)
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleDelete = () => {
		deleteRank({ id })
	}

	return (
		<AlertDialog open={open} onOpenChange={setOpen}>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบ Rank</AlertDialogTitle>
					<AlertDialogDescription>
						คุณต้องการลบแรงค์ {name} ใช่หรือไม่?
						การดำเนินการนี้ไม่สามารถย้อนกลับได้
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel disabled={isPending}>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction
						onClick={handleDelete}
						className="bg-destructive hover:bg-destructive/90"
						disabled={isPending}
					>
						{isPending ? 'กำลังลบ...' : 'ลบ'}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
